import Cookies from "universal-cookie";
import { getUtmData } from "./utmTracking";

/**
 * Extracts the referral source value from UTM data (with cookie fallback).
 * Returns the value in the format expected by the backend's referredBy field.
 *
 * Priority: UTM params > cookie
 *
 * Uses "::" as separator between source and campaign.
 * Example: utm_source=Ambassador&utm_campaign=Rae Ingram → "Ambassador::Rae Ingram"
 */
export function getReferredByValue(): string | undefined {
  // Try UTM data first
  const utmData = getUtmData();
  if (utmData) {
    try {
      const parsed = JSON.parse(utmData);
      const utmSource = parsed.utm_source;

      if (!utmSource) {
        return getFallbackFromCookie();
      }

      // If there's a campaign, join with "::"
      if (parsed.utm_campaign) {
        return `${utmSource}::${parsed.utm_campaign}`;
      }

      // Just the source
      return utmSource;
    } catch (e) {
      console.error("Error parsing UTM data:", e);
    }
  }

  // Fall back to cookie for backwards compatibility
  return getFallbackFromCookie();
}

/**
 * Gets referral value from cookie (backwards compatibility fallback)
 */
function getFallbackFromCookie(): string | undefined {
  const cookies = new Cookies();
  return cookies.get("referred-by");
}

/**
 * Checks if there's any referral source present (UTM or cookie)
 */
export function hasReferralSource(): boolean {
  return !!getReferredByValue();
}
